import axiosInstance from "../lib/axiosInstance";


const Baseurl = process.env.REACT_APP_API_URL


const couponModel = class {

    async GetList() {
        return await axiosInstance.get(Baseurl +"/coupons/");
    }
   
}

export default new couponModel();